import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBExport, DBExportType } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  exportType: DBExportType;
  exportProfileId?: number;
  format?: 'csv' | 'xlsx';
};

type Response = {
  result: DBExport;
};

export const createExport = async (
  scope: RequestScope,
  { exportType, exportProfileId, format = 'csv' }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const queryParams = [];
    if (exportProfileId && exportProfileId !== -1) {
      queryParams.push(`profile=${exportProfileId}`);
    }
    if (format === 'xlsx') {
      queryParams.push('format=xlsx');
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    const url = `${exportType}/export${queryString}`;

    const response = await scopedApi(scope).post<EndpointResponse<Response>>(url, {}, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
